"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketplaceToEaselContentViolationFlag = exports.ContentViolationFlagType = void 0;
/**
 * Possible content violation flags
 */
var ContentViolationFlagType;
(function (ContentViolationFlagType) {
    /** Copyright */
    ContentViolationFlagType["IP"] = "IP";
    /** Inappropriate content */
    ContentViolationFlagType["IC"] = "IC";
    /** UNKNOWN represent some edge cases when admins takedown content but don't specify a reason */
    ContentViolationFlagType["UNKNOWN"] = "UNKNOWN";
})(ContentViolationFlagType = exports.ContentViolationFlagType || (exports.ContentViolationFlagType = {}));
const GATEWAY_TPT_ADMIN_IC = 'INAPPROPRIATE_CONTENT';
const GATEWAY_STATUS_NOT_ACTIVE = 'NOT_ACTIVE';
/**
 * Maps MP resource status to Easel violation flag
 *
 * @param resourceStatusDetails The resource status details
 *
 * The detailed status is part of the gql-gateway resource response object
 *
 * query {
 * resource(id: RESOURCE_ID) {
 *   statusDetails {
 *     copyright
 *     tptAdmin
 *     tptAdminType
 *   }
 *  }
 * }
 *
 * @returns If the input resource status is flagged the mapped Easel content violation flag will
 * be returned, otherwise return `null`
 */
exports.marketplaceToEaselContentViolationFlag = (resourceStatusDetails) => {
    if (resourceStatusDetails.copyright === GATEWAY_STATUS_NOT_ACTIVE) {
        return ContentViolationFlagType.IP;
    }
    if (resourceStatusDetails.tptAdminType === GATEWAY_TPT_ADMIN_IC) {
        return ContentViolationFlagType.IC;
    }
    if (resourceStatusDetails.tptAdmin === GATEWAY_STATUS_NOT_ACTIVE) {
        return ContentViolationFlagType.UNKNOWN;
    }
    return null;
};
//# sourceMappingURL=index.js.map